<div class="flex flex-col flex-1 w-full">
  @switch (currentView()) {
    @case (view.SingleSelected) {
      <sd-recycle-bin-single-selected
        class="flex flex-1 overflow-hidden"
        [selectedScan]="singleSelectedScan()"
        [previewVisible]="previewVisible()"
        [disabled]="disabled()"
        (previewVisibleChanged)="previewVisibleChanged.emit($event)"
        (closeClicked)="closeClicked.emit()"
      ></sd-recycle-bin-single-selected>
    }
    @case (view.MultiSelected) {
      <sd-recycle-bin-multi-selected
        class="flex flex-1 overflow-hidden"
        [selectedScans]="selectedScans()"
        [disabled]="disabled()"
        (closeClicked)="closeClicked.emit()"
      ></sd-recycle-bin-multi-selected>
    }
  }

  <!-- button group -->
  <div class="flex p-4 justify-end border-t border-gray-1">
    <button
      modus-stroked-button
      id="recycle-bin-options-panel-delete"
      color="secondary"
      [modus-tooltip]="translations.delete.tooltip.text"
      [disabled]="disabled()"
      (click)="deleteClicked.emit()"
    >
      <md-icon class="mr-1">delete</md-icon>
      {{ translations.delete.button.text }}
    </button>

    <button
      modus-flat-button
      id="recycle-bin-options-panel-restore"
      class="ml-4"
      [modus-tooltip]="translations.restore.tooltip.text"
      [disabled]="disabled()"
      (click)="restoreClicked.emit()"
    >
      <md-icon class="mr-1">backup_restore_file</md-icon>
      {{ translations.restore.button.text }}
    </button>
  </div>
</div>
